<template>
    <div>
        <HeaderSection icon="fas fa-user-plus" title="Editar Oficina">
            <template slot="buttons">
                <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion/oficinas')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <el-form >
            <el-row :gutter="20">
                
                <el-col :span="6">
                    <el-form-item label="Tipo de Oficina" 
                        prop="type"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                            <el-input placeholder="Nombre" v-model="form.type"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="Ubicación" 
                        prop="location"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                            <el-input placeholder="Nombre" v-model="form.location"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="Ciudad" 
                        prop="city"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                            <el-input placeholder="Nombre" v-model="form.city"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="País"
                        prop="country"
                        :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                            <el-input placeholder="Nombre" v-model="form.country"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <br>
            <el-row :gutter="20">
                <el-col :span="24" align="end">
                    <el-button
                            size="medium"
                            type="danger"
                            icon="el-icon-arrow-left"
                            @click="$router.push('/administracion/oficinas')">
                        Cancelar
                    </el-button>
                    <el-button
                            type="primary"
                            size="medium"
                            icon="far fa-save"
                            @click="submitForm()">
                        Guardar
                    </el-button>
                </el-col>
            </el-row>

        </el-form>

        
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';
    import HeaderSection from '../../../partials/HeaderSection';
   
    export default {
        components: {
            HeaderSection,
        },    

        mounted() {

            let _this = this;

            this.$store.dispatch(
                'loading/spinner', { msg: 'Cargando Datos...', status: true }, { root: true });

            axios.get(`/api/offices/${this.$route.params.id}/edit`).then(response => {

                _this.form.id = response.data.office.id;
                _this.form.type = response.data.office.type;
                _this.form.location = response.data.office.location;
                _this.form.city = response.data.office.city;
                _this.form.country = response.data.office.country;

                this.$store.dispatch('loading/spinner', {}, { root: true });

            }).catch(error => {

                this.$notify.error({
                    title: 'Error',
                    message: 'Ocurrió un error inesperado al mostrar los datos de oficina'
                });

            });
        },        

        data() {
            return {
                isOfficeValid: false,
                form: {
                  type: '',
                  location: '',
                  city: '',
                  country: '',
                },
                
            }
        },
             
        computed: {
            ...mapState([
                'route'
            ]),
            
        },



        methods: {
             showLoading() {
                this.$store.dispatch('loading/spinner',
                    {msg: 'Cargando Datos...', status: true}, {root: true});
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            submitForm() {
                let _this = this;

                _this.showLoading();

                var newOffice = _this.form;

                axios.put('/api/offices/'+ _this.form.id, newOffice).then(response => {
                    _this.hideLoading();

                    _this.$notify({
                        type: 'success',
                        title: 'Éxito',
                        message: response.data.message
                    });

                    _this.$router.push('/administracion/oficinas');
                }).catch(error => {
                    _this.hideLoading();

                    _this.$notify({
                        type: 'error',
                        title: 'Error',
                        message: 'No fue posible registrar la oficina, inténtelo nuevamente.'
                    });
                });
            },

        }
    }
</script>

<style>
    
</style>
